import axios from 'axios'
import { User } from '../../models/user'
import { API_ROUTES } from '../routes'

export const getUser = async (userId: string) => {
  return axios.get<User>(API_ROUTES.USER + userId)
}
